import {MenuItemLink} from 'react-admin';
import {styled} from '@mui/material/styles';

const StyledMenuItemLink = styled(MenuItemLink)(({theme}) => ({
  '&& .MuiListItemIcon-root': {
    color: 'rgba(255, 255, 255, 0.5)',
  },
  color: '#fff',
  '&:hover': {
    color: theme.palette.secondary.main,
    '&& .MuiListItemIcon-root': {
      color: theme.palette.secondary.main,
    },
  },
  '&.RaMenuItemLink-active': {
    color: theme.palette.secondary.main,
    fontWeight: 'bold',
    '&& .MuiListItemIcon-root': {
      color: theme.palette.secondary.main,
    },
  },
}));

const CustomMenuItemLink = (props: any) => {
  return <StyledMenuItemLink {...props} />;
};

export default CustomMenuItemLink;
